import { getRecordDataByFieldInclusion } from "@/Utils/DataLib";
import { GetDoc } from "@/Utils/StateLib";
import {
  enumObjClassNames,
  enumObjectTypes,
  kLocationID,
  kPositionEndDate,
  kPositionLocation,
  kPositionStartDate
} from "@coreapp/constants";
import { QXDoc } from "@coreapp/CoreApp/QPlanManager";

export enum ProfileTypes {
  Employee = "employee",
  Position = "position",
  Agent = "agent"
}

export const getTabFieldData = (
  visibleFields: string[],
  record: Record<string, any>,
  type: ProfileTypes
) => {
  const recordDataCopy = record ? JSON.parse(JSON.stringify(record)) : {};

  // Avoid normalization when getting position fields if the document has no position class
  const doc = GetDoc();
  const normalize = (doc && doc.GetPositionClass() !== null) || type !== ProfileTypes.Position;

  let otherFieldData = getRecordDataByFieldInclusion(
    recordDataCopy,
    visibleFields,
    normalize,
    false,
    type === ProfileTypes.Position ? enumObjClassNames.position : enumObjClassNames.box,
    true
  );

  if (!normalize) {
    otherFieldData = Object.keys(otherFieldData).map((field: string) => {
      {
        // For position types, we need to return the raw value for location fields
        return {
          value: otherFieldData[field],
          field,
          fieldDef: null
        };
      }
    });
  }

  // Trim any fields that are not allowed to be visible per Chart Settings
  otherFieldData.map((field: any) => {
    if (!visibleFields.includes(field.field)) {
      delete otherFieldData[field.field];
    }
  });

  return otherFieldData;
};

export const getLocationFieldName = (doc: QXDoc, objClassName: string, objType: string) => {
  const objDb = doc.GetObjDB();
  const objClass = objDb?.GetClassByName(objClassName);

  if (objType === enumObjectTypes.position) {
    let locationField = objClass?.GetFieldDefByID(kPositionLocation);
    if (!locationField) {
      locationField = objClass?.GetFieldDefByID(kLocationID);
    }
    return locationField?.GetFieldName() || kLocationID;
  } else {
    let locationField = objClass?.GetFieldDefByID(kLocationID);
    return locationField?.GetFieldName() || kLocationID;
  }
};

export const getPositionDatesFieldNames = (doc: QXDoc) => {
  const objDb = doc.GetObjDB();
  const positionClass = objDb?.GetClassByName(enumObjClassNames.position);
  if (!positionClass) {
    return {};
  }

  const startDateFieldDef = positionClass.GetFieldDefByID(kPositionStartDate);
  const endDateFieldDef = positionClass.GetFieldDefByID(kPositionEndDate);

  return {
    startDateFieldName: startDateFieldDef ? startDateFieldDef.GetFieldName() : kPositionStartDate,
    endDateFieldName: endDateFieldDef ? endDateFieldDef.GetFieldName() : kPositionEndDate
  };
};
